module.exports = __webpack_public_path__ + "static/media/22ESCWA22.cdd0d626.jpg";